import React from 'react';
import { AnimatedHeadText } from '../../utils/customStyles';
import { AnimatedWords } from './animateStyle';

const AnimatedHeader = ({ letterClass, strArray, idx }) => {
  return (
    <AnimatedWords>
      {strArray.map((char, i) => (
        <AnimatedHeadText
          key={char + i}
          letterClass={letterClass}
          aria-hidden='true'
          delayCount={i + idx}
        >
          {char}
        </AnimatedHeadText>
      ))}
    </AnimatedWords>
  );
};

export default AnimatedHeader;
